<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
      isPasswordVisible: false,
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      tags: ["English", "French"],
      title: "Favourites",
      text: "Customer",
      text1: "Favourites",
      GenMaleSel: ["Select Gender", "Male", "Female"],
      AudSel: ["Choose Currency", "Eur", "Aud"],
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/customer-settings/account-settings");
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <!-- Breadcrumb -->
  <page-breadcrumb :title="title" :text="text" :text1="text1" />
  <!-- /Breadcrumb -->
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-3 col-lg-4">
            <customer-sidebar></customer-sidebar>
          </div>
          <div class="col-xl-9 col-lg-8">
            <h4 class="mb-3">Account Settings</h4>
            <h6 class="mb-4">Profile Picture</h6>
            <div class="d-flex align-items-center mb-4">
              <span class="avatar avatar-xl me-2">
                <img
                  src="@/assets/img/profiles/avatar-02.jpg"
                  class="rounded-circle"
                  alt="user"
                />
              </span>
              <div>
                <a href="" class="btn btn-dark me-2 mb-2"
                  ><i class="feather-upload-cloud me-1"></i>Upload</a
                >
                <a href="javascript:void(0);" class="btn btn-light mb-2">Remove</a>
                <p>
                  *image size should be at least 320px big,and less then 500kb. Allowed
                  files .png and .jpg.
                </p>
              </div>
            </div>
            <h6>General Information</h6>
            <div class="general-info mb-0">
              <div class="row mb-4">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Name</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">User Name</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Email</label>
                    <input type="email" class="form-control" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Mobile Number</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Gender</label>
                    <vue-select
                      :options="GenMaleSel"
                      id="genmalesel"
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Date of birth</label>
                    <div class="input-icon position-relative">
                      <span class="input-icon-addon"><i class="ti ti-calendar"></i></span>
                      <date-picker
                        v-model="startdate"
                        placeholder=""
                        class="datetimepicker form-control"
                        :editable="true"
                        :clearable="false"
                        :input-format="dateFormat"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  <div class="mb-3">
                    <label class="form-label d-block">Your Bio</label>
                    <textarea class="form-control" rows="5"></textarea>
                  </div>
                </div>
              </div>
              <h6 class="user-title">Address</h6>
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Address</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Country</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">State</label>
                    <input type="email" class="form-control" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">City</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Postal Code</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Currency Code</label>
                    <vue-select
                      :options="AudSel"
                      id="audsel"
                      placeholder="Choose Currency"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Language</label>
                    <vue3-tags-input
                      class="input-tags form-control"
                      type="text"
                      data-role="tagsinput"
                      name="specialist"
                      id="specialist"
                      :tags="tags"
                    />
                  </div>
                </div>
              </div>
              <div class="acc-submit d-flex justify-content-end align-items-center">
                <a href="javascript:void(0);" class="btn btn-light me-2">Cancel</a>
                <a href="javascript:void(0);" class="btn btn-dark">Save Changes</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->
</template>
